import React, { useMemo } from "react";
import {
  ObjectSubSystemTitles,
  ObjectSubSystemCssClasses,
  SubSystemTypeEnum
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";


const getValue = (type) => {
  if (type) {
    if (type === "Base" || type === "1") return 1;
    if (type === "Attendance" || type === "2") return 2;
    if (type === "Dorm" || type === "3") return 3;
    if (type === "Sport" || type === "4") return 4;
    if (type === "Food" || type === "5") return 5;
  } else return 0;
};


const setRow = (row) => {
  return (
    < span
      className={`label label-lg label-light-${ObjectSubSystemCssClasses[getValue(row.subSystemType)]} label-inline`
      }
    >
      <FormattedMessage id={ObjectSubSystemTitles[getValue(row.subSystemType)]} />
    </span >
  )
}

export const SubSystemColumnFormatter = (cellContent, row) => setRow(row);

export const indexN = (cellContent, row, index) => {
  return (<div>{index}</div>)
}